import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { SideSliderComponent } from './side-slider.component';

@NgModule({
    imports: [TwcModule, CommonModule, FormsModule, TranslateModule],
    declarations: [SideSliderComponent],
    exports: [SideSliderComponent],
})
export class SideSliderModule {}
